<template>
  <div class="contact-card-single">
    <Upgrade-Popup
      v-if="showPopup"
      :upgradePopupType="upgradePopupType"
      v-on:clickedOutside="showPopup = false"
    />
    <Credit-Limit-Popup
      v-if="showCreditLimitPopup"
      v-on:clickedOutside="showCreditLimitPopup = false"
    />
    <Review-Popup
      v-if="showReviewPopup"
      v-on:reviewPopupClosed="showReviewPopup = false"
    />

    <Activation-Popup
      v-if="showActivationPopup"
      v-on:closed="showActivationPopup = false"
    />

    <Linkedin-Connect-Popup
      v-if="showLinkedInConnect"
      v-on:success="
        showLinkedInConnect = false
        triggerViewEmail()
      "
      v-on:failed="
        showLinkedInConnect = false
        showUpgradePopup('li_connect_multi')
      "
      v-on:close="showLinkedInConnect = false"
      v-on:skip="
        showLinkedInConnect = false
        showUpgradePopup('li_connect_skip')
      "
    />

    <div v-if="!loading && profileData" class="user-info animate-fadein">
      <div class="user-name-title-section">
        <div class="name width-100" v-if="profileData.fullName">
          {{ profileData.fullName }}
        </div>
        <div class="title float-l width-100" v-if="profileData.title">
          {{ profileData.title }}
        </div>
      </div>
      <Spinner v-if="loadingSpinnerEmail || dataLoadingInBg" />
      <div class="user-email-section" v-else>
        <div
          class="get-email-btn"
          v-if="!profileData.email && !errorMsg.msg && !errorMsg.butText"
        >
          <V-Button
            :callback="findEmailSmtp"
            :text="'Find email'"
            :loading="false"
          />
        </div>
        <div v-if="!profileData.email && errorMsg" class="diff-domain-section">
          <span v-if="errorMsg.msg" class="errorMsg">{{ errorMsg.msg }}</span>
          <span
            v-if="errorMsg.butText"
            class="diff-domain-btn-section no-domain"
          >
            <Add-Domain-Find-Email-But
              class="flex-c"
              :text="errorMsg.butText"
              :type="'domain'"
              :data="profileData"
              v-on:newDomainSubmitted="findEmailWithCustomDomain"
            />
          </span>
        </div>
        <div
          class="email-section animate-fadein txt-blue"
          v-if="profileData.email"
        >
          <Email-Icon
            viewBox="2 5 22 12"
            width="14px"
            height="14px"
            class="email-icon"
          />
          <div class="email-holder">
            <span
              :class="[{ cursor: !canShowButton() }, 'email-address noselect']"
              @mouseover="showCopyMsg = true"
              @mouseout="showCopyMsg = false"
              @click="
                copyClipboard(
                  profileData.mcId
                    ? profileData.mcId
                    : profileData.masterContactId,
                  profileData.email,
                  'email'
                )
                showCopyMsg = true
              "
            >
              {{ profileData.email }}
              <span v-if="showCopyMsg && !canShowButton()" class="tooltip"
                >Click to copy</span
              >
            </span>
            <div class="copy-domain-score-section" v-if="!canShowButton()">
              <div
                class="copy-email-section"
                title="Click to Copy"
                @click="
                  copyClipboard(
                    profileData.mcId
                      ? profileData.mcId
                      : profileData.masterContactId,
                    profileData.email,
                    'email'
                  )
                "
              >
                <input
                  type="text"
                  :value="profileData.email"
                  class="noVisibility"
                  :id="
                    (profileData.mcId
                      ? profileData.mcId
                      : profileData.masterContactId) + 'email'
                  "
                />
                <Copy-Icon />
              </div>
              <div>
                <Try-Different-Domain-Icon
                  v-if="
                    profileData.email &&
                      profileData.contactAlreadyOwned === true
                  "
                  :text="'Try for a different domain'"
                  :type="'domain'"
                  :data="profileData"
                  v-on:newDomainSubmitted="findEmailWithCustomDomain"
                />
              </div>
              <div v-if="profileData.emailDeliverability && !canShowButton()">
                <Email-confidence-card
                  class="fn-14"
                  :score="profileData.emailDeliverability"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="get-email-btn"
          v-if="profileData.email && !profileData.contactAlreadyOwned"
        >
          <Find-Email-Button
            ref="viewEmailButton"
            :contactName="profileData.fullName"
            :contactCompany="profileData.companyName"
            :masterContactId="profileData.masterContactId"
            v-on:response="updatePhoneAndEmail"
            :showUpgradePopup="showUpgradePopup"
            :enableReviewPopup="enableReviewPopup"
            :showActivationPopup="showActivationError"
            :showLinkedInConnect="showLinkedInConnectPrompt"
            :fromLiSingle="true"
            :enableSalesgearPromotionPopup="enableSalesgearPromotionPopup"
          />
        </div>

        <div
          class="create-add-list"
          v-if="profileData.email && profileData.contactAlreadyOwned == true"
        >
          <Create-List
            :contactId="[
              profileData.mcId ? profileData.mcId : profileData.masterContactId
            ]"
            :listType="'single'"
            v-on:addToListUpgrade="showUpgradePopup"
            :showActivationPopup="showActivationError"
          />
        </div>
      </div>
      <div class="crm-section" v-if="canShowCRMButton()">
        <Crm-Export
          :userEmail="profileData.email"
          v-on:crmUpgradePopup="showUpgradePopup"
          :contactData="profileData"
          :contactId="
            profileData.mcId ? profileData.mcId : profileData.masterContactId
          "
          :pageType="'single'"
          :companyData="companyData"
          :showActivationPopup="showActivationError"
        />
      </div>
      <div
        class="user-detail-section"
        v-if="profileData.level || profileData.department"
      >
        <div v-if="profileData.phone" class="phone-info">
          <div
            class="txt-blue"
            v-for="(ele, index) in profileData.phone"
            :key="index"
          >
            <Phone-Card
              v-if="ele.score == 'high'"
              :phone="ele"
              :contactsOwned="profileData.contactAlreadyOwned"
              :profileData="profileData"
            />
          </div>
        </div>
        <div class="view-contact-btn-holder" v-if="!loadingCompany">
          <div
            class="view-all"
            v-if="conatactCount && companyData && companyData.primaryDomain"
            @click="showAllOtherContact"
            :data-link="companyData.primaryDomain"
          >
            <span>
              View {{ conatactCount | formatNumber }}
              {{ conatactCount | singularPlural('contact') }} from
              {{ companyData.name }}
            </span>
          </div>
        </div>
        <div class="level" v-if="profileData.level">
          <Decision-Maker />
          <span>{{ getLevelNameFromLevel(profileData.level) }}</span>
        </div>
        <div class="portfolio" v-if="profileData.department">
          <Portfolio />
          <span>{{ profileData.department.join(', ') }}</span>
        </div>
      </div>
    </div>

    <div v-else class="placeholder">
      <div class="name-title-section">
        <div class="name linear-background"></div>
        <div class="title linear-background"></div>
      </div>
      <div class="email-card"></div>
      <div class="crm-section">
        <Crm-Export-Loader />
      </div>
      <div class="user-card">
        <div>
          <div class="icon linear-background"></div>
          <div class="label-name linear-background"></div>
        </div>
      </div>
      <div class="view-contact" v-if="!loadingCompany && companyData">
        <div class="btn linear-background"></div>
      </div>
      <div class="user-card">
        <div>
          <div class="icon linear-background"></div>
          <div class="label-name linear-background"></div>
        </div>
        <div>
          <div class="icon linear-background"></div>
          <div class="label-name linear-background"></div>
        </div>
      </div>
    </div>

    <div v-if="!loadingCompany" class="company-info-section">
      <div
        v-if="!loadingCompany && companyData"
        class="company-info animate-fadein"
      >
        <div class="decision-link-head" v-if="companyData.name">
          {{ companyData.name }}
        </div>
        <div
          class="decision-link"
          v-if="companyData && companyData.primaryDomain && companyData.website"
        >
          <Decision-Link />
          <a :href="companyData.website" target="_blank" class="txt-blue">{{
            companyData.primaryDomain
          }}</a>
        </div>
        <div
          class="company-count d-flex float-l width-100"
          v-if="companyData.employeeCount"
        >
          <Company-Count />
          <span>{{ companyData.employeeCount }}</span>
        </div>
        <div
          class="revenue d-flex float-l width-100"
          v-if="companyData.revenue"
        >
          <Revenue />
          <span>{{ companyData.revenue }}</span>
        </div>
        <div
          class="industry d-flex float-l width-100"
          v-if="companyData.industry"
        >
          <Industry-Icon />
          <span>{{ companyData.industry }}</span>
        </div>
        <div
          class="location d-flex float-l width-100"
          v-if="
            companyData.street ||
              companyData.city ||
              companyData.state ||
              companyData.country
          "
        >
          <Location />
          <span
            v-html="
              formatLocationString(
                companyData.street,
                companyData.city,
                companyData.state,
                companyData.country
              )
            "
          ></span>
        </div>
      </div>
    </div>

    <div v-else class="placeholder">
      <div class="about-company">
        <div class="company-domain">
          <div class="company linear-background"></div>
        </div>
        <div class="company-card">
          <div>
            <div class="icon linear-background"></div>
            <div class="label-name linear-background"></div>
          </div>
          <div>
            <div class="icon linear-background"></div>
            <div class="label-name linear-background"></div>
          </div>
          <div>
            <div class="icon linear-background"></div>
            <div class="label-name linear-background"></div>
          </div>
          <div>
            <div class="icon linear-background"></div>
            <div class="label-name linear-background"></div>
          </div>
          <div>
            <div class="icon linear-background"></div>
            <div class="label-name linear-background"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneCard from './SinglePhoneCard'
import emailConfidenceCard from '@/components/EmailConfidenceCard'
import findEmailButton from '@/components/FindEmailButton'
import Button from '@/components/Button.vue'
import UpgradePopup from '@/components/UpgradePopup.vue'
import CreditLimitPopup from '@/components/CreditLimitPopup.vue'
import ReviewPopup from '@/components/ReviewPopup.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'
import LinkedinConnect from '@/components/LinkedinConnect.vue'
import sharedFunctions from '@/assets/util/functions.js'
import emailIcon from '@/assets/icons/svg/email.svg'
import { post, get } from '@/assets/util/rest.js'
import {
  advanceSearchUrl,
  TRIGGERS_TRACK_TO_LB
} from '@/assets/util/constants/constants.js'
import addDomainFindEmail from '@/components/AddDomainFindEmail'
import decisionIcon from '@/assets/icons/svg/decision-making-svgrepo-com-1.svg'
import portfolioIcon from '@/assets/icons/svg/portfolio.svg'
import decisionLinkIcon from '@/assets/icons/svg/grid-world-1.svg'
import companyCountIcon from '@/assets/icons/svg/group-2.svg'
import revenueIcon from '@/assets/icons/svg/coin-1.svg'
import locationIcon from '@/assets/icons/svg/placeholder-3.svg'
import copyIcon from '@/assets/icons/svg/copy.svg'
import industryIcon from '@/assets/icons/svg/factory.svg'
import Spinner from '@/components/Spinner'
import { MxEvent } from '@/assets/util/constants/analytics'
import CrmExportLoader from '@/components/crmExport/CrmExportLoader.vue'
import CrmExport from '@/components/crmExport/CrmExport.vue'
import CreateList from '@/components/CreateList'
//import CreateListFloatingLabel from '@/components/CreatelistFloatingLabel'
import TryDifferentDomainIcon from '@/components/TryDifferentDomain'

export default {
  name: 'SingleContactCard',
  props: [
    'profileData',
    'loading',
    'companyData',
    'conatactCount',
    'loadingCompany',
    'error',
    'dataLoadingInBg'
  ],
  watch: {
    error: {
      handler(newValue, oldValue) {
        if (oldValue != newValue) {
          this.errorMsg = newValue
        }
      }
    },
    profileData: {
      handler() {
        this.errorMsg = { msg: null }
      }
    }
  },
  data: function() {
    return {
      trySMPT: false,
      addButtonLoading: false,
      smtpCompleted: false,
      showPopup: false,
      showCreditLimitPopup: false,
      errorMsg: {
        msg: null
      },
      upgradePopupType: null,
      showReviewPopup: false,
      showActivationPopup: false,
      loadingSpinnerEmail: false,
      showCopyMsg: false,
      showLinkedInConnect: false,
      showDomainTooltip: false,
      showSalesgearSchedule: false,
      showSalesgearPromotionPopup: false
    }
  },
  computed: {
    isSalesgearExportEnabled: function() {
      return this.$store.state.salesgear.showSalesgearExportOption
    },
    isPaidUser: function() {
      return this.$store.state.header.isPaidUser
    },
    isAccountVerified: function() {
      return this.$store.state.header.emailStatus == 0
    }
  },
  components: {
    'Phone-Card': PhoneCard,
    'Email-confidence-card': emailConfidenceCard,
    'Email-Icon': emailIcon,
    'Add-Domain-Find-Email-But': addDomainFindEmail,
    'Decision-Maker': decisionIcon,
    Portfolio: portfolioIcon,
    'Decision-Link': decisionLinkIcon,
    'Company-Count': companyCountIcon,
    Revenue: revenueIcon,
    Location: locationIcon,
    'Find-Email-Button': findEmailButton,
    'V-Button': Button,
    'Copy-Icon': copyIcon,
    'Industry-Icon': industryIcon,
    'Upgrade-Popup': UpgradePopup,
    'Review-Popup': ReviewPopup,
    'Activation-Popup': ActivationPopup,
    'Linkedin-Connect-Popup': LinkedinConnect,
    Spinner: Spinner,
    'Crm-Export': CrmExport,
    'Crm-Export-Loader': CrmExportLoader,
    'Create-List': CreateList,
    'Try-Different-Domain-Icon': TryDifferentDomainIcon,
    'Credit-Limit-Popup': CreditLimitPopup,
  },
  methods: {
    updatePhoneAndEmail(res) {
      this.profileData.email = res.email
      this.profileData.phone = res.phone
      this.profileData.mcId = res.masterContactId
      this.profileData.contactAlreadyOwned = true
    },
    findEmailSmtp() {
      const filteredData = sharedFunctions.getFilteredData(
        this.profileData,
        false
      )
      this.findEmail(filteredData)
    },
    findEmailWithCustomDomain(inputData) {
      sharedFunctions.track(MxEvent.tryDifferentDomain, {}, this.$store.state)
      this.profileData.domain = inputData.domain
      this.profileData.companyName = inputData.companyName
      this.profileData.title = null
      this.profileData.level = null
      this.profileData.email = null
      this.profileData.phone = null
      this.profileData.department = null
      this.companyData = null
      this.errorMsg.msg = null
      let customData = {}
      customData.fullName = this.profileData.fullName
      customData['experience'] = [
        {
          isVerifiedDomain: false,
          isActivelyWorking: true,
          domain: inputData.domain,
          companyName: inputData.companyName
        }
      ]
      this.findEmail(customData)
    },
    doNothing() {},
    getLevelNameFromLevel(level) {
      let levelName = null
      if ('C-Level' === level || 'VP-Level' === level) {
        levelName = 'Decision maker'
      } else if ('Director-Level' === level) {
        levelName = 'Influencer'
      } else if ('Manager-Level' === level) {
        levelName = 'Champion'
      } else {
        levelName = level
      }
      return levelName
    },
    canShowCRMButton() {
      return (
        this.profileData &&
        this.profileData.email &&
        this.profileData.contactAlreadyOwned == true
      )
    },
    canShowButton() {
      return (
        this.profileData.domain &&
        (!this.profileData.email || this.profileData.email.indexOf('*') != -1)
      )
    },
    findEmail(data) {
      if (data) {
        this.loadingSpinnerEmail = true
        let that = this
        post('lp/email.htm', data)
          .then(response => {
            setTimeout(function() {
              that.loadingSpinnerEmail = false
              if (response.status == 200) {
                response.json().then(res => {
                  if (res.statusCode == '200') {
                    that.profileData = res.response
                    that.profileData.contactAlreadyOwned = true
                    let companyId =
                      res.response && res.response.companyId
                        ? res.response.companyId
                        : ''
                    if (companyId != '') {
                      that.getCompanyData(companyId)
                      that.getContactCount(companyId)
                    }
                  } else if (res.statusCode == '400') {
                    that.showActivationError()
                  } else if (res.statusCode == '402') {
                    that.showUpgradePopup('views')
                  } else if (res.statusCode == '420') {
                    that.setShowCreditLimitPopup()
                  } else {
                    that.profileData ? (that.profileData.email = null) : ''
                    // console.log('respons msgs :' + res)
                    if (res.error && res.error[0] && res.error[0].code) {
                      that.errorMsg = that.getErrorMsg(res)
                    } else {
                      that.errorMsg = { msg: res.errorMessage }
                    }
                  }
                })
              }
            }, 2000)
          })
          .catch(e => {
            that.loadingSpinnerEmail = false
            console.log('error: ' + e)
          })
      }
    },
    copyClipboard(cId, mail, name) {
      if (!this.canShowButton()) {
        let txtDisplay = 'Copied'
        const dataMap = {
          pageType: 'Single'
        }
        sharedFunctions.clickToCopy(
          cId,
          mail,
          name,
          null,
          dataMap,
          txtDisplay,
          this.$store.state
        )
      }
    },
    checkAndShowUnlimitedCopyPromo() {
      if (this.canShowUnlimitedCopyMsg()) {
        const that = this
        setTimeout(function() {
          that.upgradePopupType = 'promo_unlimited_copy'
          that.showPopup = true
        }, 2000)
      }
    },
    canShowUnlimitedCopyMsg() {
      const _KEY = 'unlimited_copy_msg_shown'
      const alreadyShown = localStorage.getItem(_KEY)
      if (alreadyShown || this.isPaidUser) {
        return false
      } else {
        localStorage.setItem(_KEY, true)
        return true
      }
    },
    showAllOtherContact(e) {
      let domain =
        e && e.currentTarget ? e.currentTarget.getAttribute('data-link') : ''
      const dataMap = {
        pageType: 'Single'
      }
      sharedFunctions.track(MxEvent.viewAllLeads, dataMap, this.$store.state)
      if (!this.isAccountVerified) this.showActivationError()
      else if (domain != '')
        window.open(
          advanceSearchUrl(
            domain,
            this.$store.state.header.uiVersion,
            TRIGGERS_TRACK_TO_LB.SINGLE_VIEW_CONTACTS
          )
        )
    },
    getErrorMsg(res) {
      return sharedFunctions.getRespectiveErrorMsg(res)
    },
    showUpgradePopup(type) {
      if (type === 'credit_limit') {
        this.setShowCreditLimitPopup()
      } else {
        this.upgradePopupType = type
        this.showPopup = true
      }
    },
    setShowCreditLimitPopup() {
      this.showCreditLimitPopup = true
    },
    showActivationError() {
      this.showActivationPopup = true
    },
    showLinkedInConnectPrompt() {
      this.showLinkedInConnect = true
    },
    enableReviewPopup() {
      this.showReviewPopup = true
    },
    enableSalesgearPromotionPopup() {
      this.showSalesgearPromotionPopup = true
    },
    getCompanyData(compId) {
      this.loadingCompany = true
      get('lp/getCompany.htm?id=' + compId)
        .then(response => {
          this.loadingCompany = false
          if (response.status == 200) {
            response
              .json()
              .then(res => {
                this.companyData = res
              })
              .catch(e => {
                this.loadingCompany = false
                console.log('err: ' + e)
              })
          } else {
            this.loadingCompany = false
            console.log('status: ' + response.status)
          }
        })
        .catch(e => {
          this.loadingCompany = false
          console.log('error: ' + e)
        })
    },
    getContactCount(compId) {
      get('lp/company/' + compId + '/contactCount.htm')
        .then(response => {
          if (response.status == 200) {
            response
              .json()
              .then(res => {
                this.conatactCount = res
              })
              .catch(e => {
                console.log('err: ' + e)
              })
          } else {
            console.log('status: ' + response.status)
          }
        })
        .catch(e => {
          console.log('error: ' + e)
        })
    },
    formatLocationString(street, city, state, country) {
      let str = ''
      str = str + (street ? street + (city ? ', </br> ' : '') : '')
      str = str + (city ? city + (state ? ',</br> ' : '') : '')
      str = str + (state ? state + (country ? ', </br>' : '') : '')
      str = str + (country ? country + '' : '')
      return str
    },
    triggerViewEmail() {
      this.$refs.viewEmailButton.findEmail()
    },
    scheduleNow() {
      this.showSalesgearSchedule = false
    },
    setSalesgearSchedule() {
      if (localStorage.getItem('SalesgearIntroBanner')) {
        this.showSalesgearSchedule = false
      } else {
        this.showSalesgearSchedule = true
      }
    },
    canSchedule() {
      if (this.showSalesgearSchedule && this.profileData.email) {
        return !(
          this.profileData.email && this.profileData.email.indexOf('*') != -1
        )
      } else {
        return false
      }
    }
  },
  created() {
    this.setSalesgearSchedule()
  },
  beforeMount() {
    this.setSalesgearSchedule()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin sequneceStyle {
  cursor: pointer;

  .dropdown-wrapper {
    left: -20px;
    top: 35px;

    .sharp__pointer {
      left: 23px;
    }
  }

  .spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    > div {
      width: 6px;
      height: 6px;
    }
  }
}

.contact-card-single {
  width: 100%;
  color: $grey-color;
  position: relative;
  line-height: 1.5;
  .user-info {
    display: flex;
    flex-direction: column;
    .user-name-title-section {
      display: flex;
      flex-direction: column;
      padding: 15px 10px;
      .name {
        font-size: 16px;
        @extend .ellipsis;
        color: $black;
      }
      .title {
        color: $grey-color;
        font-size: 14px;
        @extend .ellipsis;
      }
    }
    .user-email-section {
      background-color: #f6f6f6;
      padding: 20px 10px;
      .get-email-btn::v-deep {
        margin: 0;
        button {
          border-radius: 20px;
          border-width: 1px;
          padding: 7px 15px;
        }
      }
      .diff-domain-section {
        position: relative;
        .errorMsg {
          display: flex;
          font-size: 14px;
          color: red;
          line-height: 22px;
        }
        .diff-domain-btn-section {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          div {
            margin-right: 9px;
          }
          &.no-domain {
            border-radius: 18.5px;
            color: #636a72;
            padding: 0px 5px;
            font-size: 12px;
            width: fit-content;
            margin-top: 7px;
            line-height: 22px;
            cursor: pointer;
            border: solid 1px #a4a9af;
            svg {
              fill: $orange;
            }
          }
        }
      }
      .email-section {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        svg {
          fill: $primary-color;
        }
        .email-icon {
          margin-top: 4px;
        }
        .email-holder {
          position: relative;
          padding-left: 10px;
          width: 100%;
          margin-bottom: 5px;
          line-height: initial;
          .email-address {
            word-break: break-all;
          }
          .copy-domain-score-section::v-deep {
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 7px;
            transition: all 300ms ease;

            .email-wrap {
              @include relBlock;
              width: 24px;
              height: 24px;
              font-size: 13px;
              margin-right: 7px;
              border-radius: 35px;
              border: 1px solid $border-dark;
              @include flex-center;
              justify-content: center;

              .salesgearSequence {
                @include sequneceStyle();
                .dropdown-wrapper {
                  top: 25px;
                  left: -24px;
                }
              }

              a {
                color: unset;
                text-decoration: none;
                i {
                  color: $grey-color;
                  font-size: 16px;
                  vertical-align: middle;
                }
              }
              &:hover {
                background: #ecf2fa;
                border-color: #dce9fb;
                a i {
                  color: $ae-blue;
                }
              }
            }
            .copy-email-section {
              position: relative;
              border: 1px solid $border-dark;
              border-radius: 50%;
              width: 24px;
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 7px;
              cursor: pointer;
              transition: all 300ms ease;

              svg {
                width: 13px;
                height: 13px;
                fill: $grey-color;
              }
              &:hover svg {
                fill: $primary-color;
              }
              &:hover {
                background: #ecf2fa;
                border-color: #ecf2fa;
              }
              input {
                border: none;
                width: 100%;
                height: 1px;
                opacity: 0;
                box-shadow: none;
                outline: none;
                position: absolute;
                top: 10px;
                left: 5px;
                z-index: -1;
              }
            }
          }
        }
      }
      .create-add-list {
        padding: 20px 0 5px;
        transition: all 300ms ease;
      }
    }
    .crm-section {
      padding: 5px 0;
      border-bottom: 1px solid #f5f5f5;
      transition: all 300ms ease;
    }
    .user-detail-section {
      display: flex;
      flex-direction: column;
      padding: 10px 15px;
      .phone-info {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        padding: 5px 0;
        .phone-card::v-deep {
          color: #636a72;
          .phone-title {
            font-size: 13px;
          }
          svg {
            width: 16px;
            height: 16px;
            fill: $icon-black;
            display: flex;
          }
          i {
            font-size: 24px;
          }
        }
      }
      .level {
        border-bottom: 1px solid $light-border;
        padding: 10px 0;
      }
      .portfolio {
        padding-top: 10px;
      }
      .level,
      .portfolio {
        min-width: fit-content;
        span {
          margin-left: 15px;
          font-size: 15px;
        }
        svg {
          width: 15px;
          height: 15px;
          fill: $icon-black;
        }
      }
    }
  }
  .company-info-section {
    position: relative;
    background-color: #f6f6f6;
    .company-info {
      padding: 20px 10px;
      display: flex;
      flex-direction: column;
      width: 100%;
      .decision-link-head {
        font-size: 16px;
        text-align: left;
        color: $black-text-light;
        margin-bottom: 5px;
      }
      .decision-link,
      .company-count,
      .revenue,
      .industry,
      .location {
        display: flex;
        min-width: fit-content;
        margin-top: 10px;
        span,
        a {
          margin-left: 15px;
          font-size: 14px;
        }
        svg {
          width: 15px;
          height: 15px;
          margin-top: 3px;
          fill: #575f68;
        }
      }
    }
  }
}
.placeholder {
  .linear-background {
    margin-top: 10px;
    min-height: 15px;
    border-radius: 3px;
  }
  .name-title-section {
    padding: 10px 10px 20px;
  }
  .email-card {
    background: #f6f6f6;
    height: 150px;
  }
  .crm-section {
    padding: 10px 0px;
    border-bottom: 1px solid #f5f5f5;
  }

  .user-card,
  .company-card {
    display: flex;
    flex-direction: column;
    div {
      display: flex;
      flex-direction: row;
      margin-top: 10px;
      padding: 0 10px;
      .icon {
        width: 20px;
        height: 15px;
        margin-right: 10px;
        margin-bottom: 20px;
      }
      .label-name {
        min-width: 240px;
        margin-bottom: 20px;
      }
    }
  }
  .company-card {
    padding: 15px 10px;
    div {
      padding: 0;
    }
  }
  .user-card div:not(:last-child) {
    border-bottom: 1px solid rgba(59, 59, 59, 0.1);
  }
  .view-contact {
    margin: 5px 0;
    .btn {
      width: 80%;
      height: 24px;
      margin: 0 auto;
    }
  }
  .about-company {
    background: #f6f6f6;
    padding: 20px 0px;
    .company-domain {
      padding: 0 10px;
    }
  }
}
</style>
